import { render } from "./matching-results-page.vue?vue&type=template&id=657f238f&scoped=true"
import script from "./matching-results-page.vue?vue&type=script&lang=js"
export * from "./matching-results-page.vue?vue&type=script&lang=js"

import "./matching-results-page.vue?vue&type=style&index=0&id=657f238f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657f238f"]])

export default __exports__